import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import {
  setupOwnCloudFlow,
  type SetupOwnCloudState,
} from './SetupOwnCloudFlow';

export default function SetupOwnCloudWizard({
  tenantId,
  recalculateAccounts,
}: {
  tenantId: string;
  recalculateAccounts: () => void;
}) {
  const { rightPanel } = useWorkspace();
  // const onFinish = async (state: SetupOwnCloudState) => {
  const onFinish = async () => {
    recalculateAccounts();
    return true;
  };

  return (
    <Wizard<SetupOwnCloudState>
      hideCloseButton={true}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[setupOwnCloudFlow]}
      initialState={{
        tenantId,
        eonBackupApplicationName: 'EonBackupApplication',
        eonBackupApplicationId: '',
        regionName: 'eastus2',
        connectType: 'subscription',
      }}
      title='Set up Eon on your own cloud'
      stepperLabels={[
        'Configure management access',
        'Set up Backup account',
        'Connect Vault account',
        'Connect source account',
      ]}
    />
  );
}
